import React from 'react';

import { EMonitorTriggerType, IMonitor } from '~/src/dash/api/monitors/monitors_models';
import { EBool } from '~/src/dash/api/types/bool';
import { ChipDelivering, ChipPending, ChipUntargeted } from '~/src/dash/utils/campaign-status';

export function monitorTriggerTypeToChip(m: EMonitorTriggerType): any {
  switch (m) {
    case EMonitorTriggerType.MonitorTriggerType_ALERT:
      return ChipUntargeted;
    case EMonitorTriggerType.MonitorTriggerType_WARNING:
      return ChipPending;
    case EMonitorTriggerType.MonitorTriggerType_ALERT_RECOVERY:
      return ChipDelivering;
    case EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY:
      return ChipDelivering;
    case EMonitorTriggerType.MonitorTriggerType_SHUTDOWN:
      return ChipUntargeted;
  }
  return ChipDelivering;
}

export function getMonitorTriggerType(monitor: IMonitor): EMonitorTriggerType {
  let biggestAlert = EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY; // represents not alerting currently
  if (!!monitor.AlertHistory) {
    for (const alert of monitor.AlertHistory) {
      if (alert.Active === Number(EBool.EBool_TRUE)) {
        switch (alert.TriggerType) {
          case EMonitorTriggerType.MonitorTriggerType_SHUTDOWN:
            return EMonitorTriggerType.MonitorTriggerType_SHUTDOWN;
          case EMonitorTriggerType.MonitorTriggerType_ALERT:
            biggestAlert = EMonitorTriggerType.MonitorTriggerType_ALERT;
          case EMonitorTriggerType.MonitorTriggerType_WARNING:
            if (biggestAlert === EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY) {
              biggestAlert = EMonitorTriggerType.MonitorTriggerType_WARNING;
            }
          default:
        }
      }
    }
  }
  return biggestAlert;
}

export function renderMonitorStatus(triggerType: EMonitorTriggerType) {
  let statusString: string = 'Good';

  if (triggerType === EMonitorTriggerType.MonitorTriggerType_ALERT) {
    statusString = 'Alert';
  } else if (triggerType === EMonitorTriggerType.MonitorTriggerType_WARNING) {
    statusString = 'Warning';
  } else if (triggerType === EMonitorTriggerType.MonitorTriggerType_SHUTDOWN) {
    statusString = 'Shutdown';
  }
  const Chip = monitorTriggerTypeToChip(triggerType);
  return <Chip label={statusString} />;
}
